module.exports = __webpack_public_path__ + "media/images/icons/consultation-06-e7f9865ba60a17918a39a957e49bd418.svg";